import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from './services/auth.service';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from './services/storage-service.service';

import {Subscription} from 'rxjs';
import {SettingsService} from './services/settings.service';
import {DialogService} from './services/dialog.service';
import gql from 'graphql-tag';
import {Apollo} from 'apollo-angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'Nova Point';
  public spinnerComponent = "";

  subscriptions: Subscription = new Subscription();

  verificationModalOpened = false;
  isNinVerified = false;
  isTinVerified = false;

  notifications: any[] = [];

  constructor(
    private dialogService: DialogService,
    public translate: TranslateService,
    public settingsService: SettingsService,
    private storageService: StorageService,
    private apollo: Apollo
  ) {

    this.translate.addLangs(['en', 'sw']);

    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'sw');
      this.translate.setDefaultLang('sw');
      this.translate.use('sw');
    } else {
      this.translate.use(localStorage.getItem('lang'));
      this.translate.setDefaultLang(localStorage.getItem('lang'));
    }

    // this.initTranslationAndRole().then();

    // const NOTIFICATIONS_SUBSCRIPTION = gql`
    //   subscription notificationSubscription {
    //     notificationSubscription
    //   }
    // `;
    //
    // this.apollo.subscribe({query: NOTIFICATIONS_SUBSCRIPTION,})
    //   .subscribe(({ data }: any) => this.notifications.push(data.notificationSubscription));
  }

  // async initTranslationAndRole(){
  //   if (this.storageService.get('currentClient')){
  //     this.store.dispatch(getAllTranslations());
  //     await this.auth.authRole();
  //   }else {
  //     await this.auth.getTranslations();
  //   }
  // }

  ngOnInit(): void {
    this.settingsService.loadTranslation();
  }


  @HostListener('document:mousemove')
  @HostListener('document:click')
  @HostListener('document:keypress')
  resetTimer(): void {
    // const accessToken = this.storageService.get('currentClient');
    // if (accessToken) {
    //   if (window.location.pathname !== '/'
    //     && window.location.pathname !== '/sign-up' && window.location.pathname !== '/landing'
    //   ) {
    //     if (this.storageService.get('category') === UserTypeEnum.GUEST) {
    //       this.isNinVerified = this.storageService.get('isNinVerified');
    //       this.isTinVerified = this.storageService.get('isTinVerified');
    //     } else {
    //       this.isNinVerified = false;
    //       this.isTinVerified = false;
    //     }
    //   }
    //
    //   if ((!this.isNinVerified || !this.isTinVerified) && !this.verificationModalOpened
    //     && this.storageService.get('category') === UserTypeEnum.GUEST) {
    //     this.verificationModalOpened = true;
    //     this.dialogService.open({ data: null, component: NidaSignUpComponent, width: '65%'}).then();
    //   }
    // }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
